import { Box, Typography } from '@mui/material';
import BannerImage from '../../assets/carrot/Carrot_Lander_Banner.png';
import { FC } from 'react';

interface IProps {
	text?: React.ReactNode;
}

const CarrotLanderBanner: FC<IProps> = ({
	text = (
		<>
			Welcome to <b>Carrot Insurance</b>
		</>
	),
}) => {
	return (
		<Box
			sx={(theme) => ({
				position: 'relative',
				backgroundImage: `url(${BannerImage})`,
				backgroundRepeat: 'no-repeat',
				backgroundSize: 'cover',
				backgroundPosition: 'center center',
				padding: 2,
				overflow: 'hidden',
				paddingBottom: '30%',
				[theme.breakpoints.down('md')]: {
					backgroundPosition: '70% 10%',
					height: '250px',
				},
				// Gradient Overlay for entire banner
				':before': {
					content: '""',
					position: 'absolute',
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					zIndex: 1, // Ensure gradient is below text but above the background image
					background:
						'linear-gradient(-69deg, rgba(255,255,255,0.1) 65%, rgba(247,209,160,1) 65%, rgba(247,209,160,1) 66%, rgba(244,182,86,1) 66%, rgba(247,188,108,1) 67%, rgba(255,180,45,1) 67%, rgba(246,139,31,1) 67%, rgba(246,139,31,1) 73%, rgba(246,170,31,1) 90%, rgba(246,170,31,1) 94%)',
					[theme.breakpoints.down('md')]: {
						background:
							'linear-gradient(-69deg, rgba(255,255,255,0.1) 60%, rgba(247,209,160,1) 60%, rgba(247,209,160,1) 61%, rgba(244,182,86,1) 61%, rgba(247,188,108,1) 62%, rgba(255,180,45,1) 62%, rgba(246,139,31,1) 62%, rgba(246,139,31,1) 68%, rgba(246,170,31,1) 90%, rgba(246,170,31,1) 94%)',
					},
				},
			})}
		>
			<Box
				sx={(theme) => ({
					position: 'absolute',
					zIndex: 2, // Ensuring this is above the gradient overlay
					top: '50%',
					left: '25%',
					bottom: 0,
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					transform: 'translate(-80%, -65%)',
					overflow: 'hidden',
					width: '30%',
					[theme.breakpoints.down('md')]: {
						transform: 'translate(-70%, -70%)',
						left: '30%',
						width: '40%',
					},
				})}
			>
				<Typography
					variant='h4'
					sx={(theme) => ({
						color: theme.palette.common.white,
						fontSize: '1.8rem',
						margin: '1.8rem',
						padding: '1rem',
						fontWeight: 400,
						[theme.breakpoints.down('md')]: {
							fontSize: '4vw',
						},
						[theme.breakpoints.down('sm')]: {
							marginY: '0.2rem',
							marginX: 0,
							padding: 0,
						},
					})}
				>
					{text}
				</Typography>
			</Box>
		</Box>
	);
};

export default CarrotLanderBanner;
